export default "__VITE_ASSET__pZEIiLbS__"